import * as React from 'react';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

function ConfirmationModal({
    isOpen,
    onOpenChange,
    title = 'Confirm Action',
    description = 'Are you sure you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    variant = 'default',
    zIndex = 'z-50',
}) {
    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        } else if (onOpenChange) {
            onOpenChange(false);
        }
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        if (onOpenChange) {
            onOpenChange(false);
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className={cn("bg-[hsl(var(--card-bg))] border-[hsl(var(--card-border))]", zIndex)}>
                <DialogHeader>
                    <DialogTitle className="text-white font-semibold">{title}</DialogTitle>
                    <DialogDescription className="text-muted-foreground">{description}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button 
                        variant="outline" 
                        onClick={handleCancel}
                        className="border-[hsl(var(--card-border))] text-white hover:bg-[hsl(var(--muted))] hover:text-white"
                    >
                        {cancelText}
                    </Button>
                    <Button 
                        onClick={handleConfirm}
                        className={cn(
                            variant === 'destructive' 
                                ? 'bg-red-600 hover:bg-red-700 text-white font-medium' 
                                : 'bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-[hsl(var(--primary-foreground))] font-medium'
                        )}
                    >
                        {confirmText}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export { ConfirmationModal };
